import { Alert } from 'flowbite-react';

const Blocked = () => {
  return (
    <div className="flex flex-col gap-4">
      <Alert color="warning">
        <div className="flex flex-col gap-2">
          <h3 className="font-semibold">Вход временно заблокирован</h3>
          <p className="text-sm">
            Ваш доступ к административной панели временно ограничен. Обратитесь
            к системному администратору для получения дополнительной информации.
          </p>
        </div>
      </Alert>
    </div>
  );
};

export { Blocked };
